(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurea-editorial"] && !Shopify.designMode) return;
  try {
    
 function initAureaPhilosophy(root) {
  root.querySelectorAll('.aurea-philosophy__video').forEach(video => {
   if (video.dataset.initialized) return;
   video.dataset.initialized = 'true';
   const preference = matchMedia('(prefers-reduced-motion: reduce)');
   const update = () => { if (preference.matches) { video.pause(); video.hidden = true; } else { video.hidden = false; video.play().catch(() => { video.hidden = true; }); } };
   video.addEventListener('error', () => { video.hidden = true; });
   preference.addEventListener('change', update); update();
  });
 }
 initAureaPhilosophy(document);
 document.addEventListener('shopify:section:load', event => initAureaPhilosophy(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurea-hero"] && !Shopify.designMode) return;
  try {
    
 function aureaCampaignVideo(root) {
  root.querySelectorAll('.aurea-campaign__video').forEach(video => {
   const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
   const update = () => { if (reduced.matches) { video.pause(); video.hidden = true; } else { video.hidden = false; video.play().catch(() => { video.hidden = true; }); } };
   video.addEventListener('error', () => { video.hidden = true; });
   reduced.addEventListener('change', update); update();
  });
 }
 aureaCampaignVideo(document);
 document.addEventListener('shopify:section:load', event => aureaCampaignVideo(event.target));
 // One lightweight scroll update per animation frame; supports Horizon's scroll container.
 function initAureaDepth(root) {
  root.querySelectorAll('.aurea-campaign--option-one').forEach(hero => {
   if (hero.aureaDepthCleanup) return;
   const media = hero.querySelector('.aurea-campaign__visual picture');
   if (!media) return;
   const enabled = matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');
   const scroller = hero.closest('.page-wrapper') || window;
   let frame = 0;
   const paint = () => {
    frame = 0;
    const bounds = hero.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -bounds.top / bounds.height));
    media.style.setProperty('--aurea-depth', enabled.matches ? (progress * 32).toFixed(2) + 'px' : '0px');
   };
   const queue = () => { if (!frame) frame = requestAnimationFrame(paint); };
   const configure = () => {
    scroller.removeEventListener('scroll', queue);
    if (enabled.matches) scroller.addEventListener('scroll', queue, { passive: true });
    queue();
   };
   enabled.addEventListener('change', configure);
   window.addEventListener('resize', queue, { passive: true });
   hero.aureaDepthCleanup = () => {
    scroller.removeEventListener('scroll', queue);
    window.removeEventListener('resize', queue);
    enabled.removeEventListener('change', configure);
    cancelAnimationFrame(frame);
   };
   configure();
  });
 }
 initAureaDepth(document);
 document.addEventListener('shopify:section:load', event => initAureaDepth(event.target));
 document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.aurea-campaign--option-one').forEach(hero => hero.aureaDepthCleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurea-spotlight"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('change', event => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.name !== 'aurea_variant' || input.disabled) return;
  const form = input.closest('.aurea-buy-form');
  if (!form) return;
  form.querySelector('input[name="id"]').value = input.value;
  form.querySelector('input[name="quantity"]').value = input.dataset.min || '1';
  form.dataset.quantityDefault = input.dataset.min || '1';
  const price = form.closest('.aurea-buy-section').querySelector('[data-aurea-price]');
  price.textContent = input.dataset.price;
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
